<template>
  <button
    type="button"
    class="w-full text-left block sm:flex sm:items-center sm:justify-between rounded-xl bg-purple-50 border border-purple-100 p-5 mb-4 hover:shadow-md transition-shadow cursor-pointer"
    @click="$emit('open-consent', consent)"
  >
    <div>
      <p class="text-xs font-semibold uppercase tracking-wide text-purple-600">Action requise</p>
      <h3 class="mt-1 text-lg font-bold text-gray-900">
        Information importante — votre contrat vélo a changé d'assureur
      </h3>
      <p class="mt-1 text-sm text-purple-600 mr-4">
        MMA a résilié le contrat collectif au 31/12/2025. Un nouveau contrat Acheel est en place, avec des conditions
        modifiées. Prononcez-vous sous
        <span class="font-bold">{{ remainingDays }} jours</span>
        — passé ce délai, votre police sera automatiquement résiliée.
      </p>
    </div>
    <span
      class="mt-3 sm:mt-0 inline-flex items-center gap-2 rounded-2xl bg-gray-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800 transition-colors whitespace-nowrap"
    >
      Me prononcer
      <ArrowRightIcon class="h-4 w-4" />
    </span>
  </button>
</template>

<script>
import { ArrowRightIcon } from "@heroicons/vue/solid";

export default {
  components: { ArrowRightIcon },

  props: {
    consent: {
      type: Object,
      required: true,
    },
    remainingDays: {
      type: Number,
      required: true,
    },
  },

  emits: ["open-consent"],
};
</script>
